import { BehaviorSubject } from 'rxjs';
import { IDict } from '../types/utility';

export default function paramsChanged(
    params$: BehaviorSubject<IDict<string>>,
    teardowns: (() => void)[]
) {
    return function(callback: (params?: IDict<string>) => void): () => void {
        const sub = params$.subscribe(callback);
        const unsub = () => sub.unsubscribe();
        teardowns.push(unsub);
        return unsub;
    };
}
